module.exports = __webpack_public_path__ + "static/media/10.7c19d0d1.jpg";